//Vue 前端相关的全局变量

var debug = false;

//后端API接口地址
var webApiServer =  debug ?
  'http://47.94.74.150:9070':   //测试环境
  'http://webapi.truthso.com';   //生产环境
// var webApiServer =  'http://101.201.112.111:9060';


//支付宝完成回调地址
var payCallbackBaseUrl = debug ?
  'http://47.94.74.150:8090' :     //测试环境
  'http://www.truthso.com';      //生产环境
// var payCallbackBaseUrl = 'http://123.57.229.116:9081';

//IP360地址
var ip360Url = debug ?
  'http://47.94.74.150:8080' :
  'https://www.ip360.net.cn';
// var ip360Url = 'http://123.57.229.116:8080';


var vcodeUrl = webApiServer + '/webapi/user/login/getCode';

export default {
  webApiServer: webApiServer,
  payCallbackBaseUrl:payCallbackBaseUrl,
  vcodeUrl: vcodeUrl,
  ip360Url: ip360Url
}

// export default{
//   vocdeUrl: server + '/user/v2/getCode',
//   server
// }



// WEBPACK FOOTER //
// ./src/assets/lib/globalConfig.js